import { render, staticRenderFns } from "./ExpandableBox.vue?vue&type=template&id=a34dcc80"
import script from "./ExpandableBox.vue?vue&type=script&lang=js"
export * from "./ExpandableBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports